import React from 'react';

const trustItems = [
  {
    icon: '✅',
    title: 'Verified Products',
    desc: 'Sourced directly from AliExpress with added fraud filtering.',
  },
  {
    icon: '💵',
    title: 'NGN Pricing',
    desc: 'See Nigerian Naira prices automatically — no guessing or converting.',
  },
  {
    icon: '⚡',
    title: 'Lightweight UI',
    desc: 'Fast, smooth, and mobile-first experience built for Nigerians.',
  },
];

const WhyTrustUs = () => {
  return (
    <section className="bg-gray-50 py-16 px-4">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-10">
          Why Trust KambiHome
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {trustItems.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md hover:shadow-lg transition p-6 text-left"
            >
              <div className="text-3xl mb-4">{item.icon}</div>
              <h3 className="text-lg font-semibold text-gray-800 mb-1">{item.title}</h3>
              <p className="text-gray-600 text-sm">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyTrustUs;
